export const color = { bg: "#000", text: "#fff", accent: "#F3B33B" } as const;
export const space = (n: number) => n * 4; // 4px grid
export const typeScale = { body: 16, h1: 32, h2: 24 } as const;
